/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
import { KTSVG } from '../../../../helpers'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { useAuth } from '../../../../../app/modules/auth'
import ConfigContext from '../../../../../app/contexts/Config/ConfigContext'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
const SidebarMenuMain = () => {
  const intl = useIntl()
  const config = React.useContext(ConfigContext)
  const { currentUser, logout } = useAuth()

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title='Inicio'
        fontIcon='bi-app-indicator'
      />

      {config.binario && (
        <SidebarMenuItem
          to='/rede'
          icon='/media/icons/duotune/abstract/abs018.svg'
          title='Minha Rede'
          fontIcon='bi-layers'
        />
      )}

      <SidebarMenuItem
        to='/meus-indicados'
        icon='/media/icons/duotune/general/gen049.svg'
        title='Meus indicados'
        fontIcon='bi-layers'
      />

      {config.unilevel && (
        <SidebarMenuItem
          to='/unilevel'
          icon='/media/icons/duotune/abstract/abs027.svg'
          title='Unilevel'
          fontIcon='bi-layers'
        />
      )}

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section  text-uppercase fs-8 ls-1' style={{color:"#fff!important", fontWeight:700}}>Financeiro</span>
        </div>
      </div>

      <SidebarMenuItem
        to='/planos'
        icon='/media/icons/duotune/ecommerce/ecm007.svg'
        title='Planos'
        fontIcon='bi-layers'
      />

      <SidebarMenuItem
        to='/minha-assinatura'
        icon='/media/icons/duotune/coding/cod002.svg'
        title='Minha Assinatura'
        fontIcon='bi-layers'
      />

      <SidebarMenuItem
        to='/extrato'
        icon='/media/icons/duotune/general/gen014.svg'
        title='Histórico Financeiro'
        fontIcon='bi-layers'
      />

      <SidebarMenuItem
        to='/minha-carteira'
        icon='/media/icons/duotune/finance/fin008.svg'
        title='Minhas Chaves Pix'
        fontIcon='bi-layers'
      />

      <SidebarMenuItem
        to='/meus-saques'
        icon='/media/icons/duotune/finance/fin005.svg'
        title='Meus Saques'
        fontIcon='bi-layers'
      />

      <SidebarMenuItemWithSub
        to='/saques'
        title='Solicitar Saque'
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/finance/fin010.svg'
      >
        <SidebarMenuItem to='/saques/rendimentos' title='Rendimentos' hasBullet={true} />
        <SidebarMenuItem to='/saques/bonificacoes' title='Bonificações' hasBullet={true} />
      </SidebarMenuItemWithSub>

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section  text-uppercase fs-8 ls-1' style={{color:"#fff!important", fontWeight:700}}>Usuário</span>
        </div>
      </div>

      <SidebarMenuItem
        to='/perfil'
        icon='/media/icons/duotune/communication/com006.svg'
        title='Meu Perfil'
        fontIcon='bi-layers'
      />

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section  text-uppercase fs-8 ls-1' style={{color:"#fff!important", fontWeight:700}}>Loja SPL</span>
        </div>
      </div>

      <div className='menu-item'>
        <a className={clsx('menu-link without-sub', {active: false})} href={`https://www.lojadaspl.com`} target='_blank'>
          <div className="menu-icon">
            <i className={clsx('bi fs-3 bi-shop')}></i>
          </div>
          <span className='menu-title'>{`Loja SPL`}</span>
        </a>
        </div>

      {/* <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
    </>
  )
}

export { SidebarMenuMain }
